import { FilterOutlined } from "@ant-design/icons";
import { Button, DatePicker, Drawer, Input, Space, Tooltip } from "antd";
import { useEffect, useState } from "react";
import { ISSUE_PARTNER_OPTIONS } from "../../helpers/Constants";
import { chipStyle, sectionLabelStyle, toggle } from "../../helpers/FilterUI";

const { RangePicker } = DatePicker;

export function IssueFilters({ value, onApply }) {
  const { deliveryPartner, lspName, dateRange } = value;
  const [open, setOpen] = useState(false);
  const [partner, setPartner] = useState(deliveryPartner);
  const [lsp, setLsp] = useState(lspName);
  const [range, setRange] = useState(dateRange);

  // Keep the drawer's draft state in sync with the committed filters, e.g.
  // when "Clear Filters" (outside the drawer) resets everything.
  useEffect(() => {
    setPartner(deliveryPartner);
    setLsp(lspName);
    setRange(dateRange);
  }, [deliveryPartner, lspName, dateRange]);

  function hasAppliedFilter() {
    return partner.length > 0 || Boolean(lsp) || Boolean(range);
  }

  function handleReset() {
    setPartner([]);
    setLsp("");
    setRange(null);
    onApply({ deliveryPartner: [], lspName: "", dateRange: null });
  }

  function applyFilters() {
    onApply({ deliveryPartner: partner, lspName: lsp, dateRange: range });
    setOpen(false);
  }

  return (
    <>
      <Tooltip title="Filter">
        <Button
          type="primary"
          shape="circle"
          icon={<FilterOutlined />}
          onClick={() => setOpen(true)}
          style={{
            borderRadius: 8,
            borderColor: hasAppliedFilter() ? "#BFDBFE" : "#E2E8F0",
            background: hasAppliedFilter() ? "#EFF6FF" : "#fff",
            color: hasAppliedFilter() ? "#1D4ED8" : "#64748B",
            boxShadow: "none",
            fontWeight: hasAppliedFilter() ? 500 : 400,
          }}
        />
      </Tooltip>
      <Drawer
        title="Filters"
        onClose={() => setOpen(false)}
        visible={open}
        extra={
          <Space>
            <Button type="text" onClick={handleReset}>
              Reset
            </Button>
            <Button type="primary" onClick={applyFilters}>
              Apply Filters
            </Button>
          </Space>
        }
      >
        <div style={{ marginBottom: 24 }}>
          <span style={sectionLabelStyle}>Delivery Partner</span>
          <Space wrap size={8}>
            {ISSUE_PARTNER_OPTIONS.map(({ label, value: val }) => (
              <Button
                key={val}
                size="small"
                style={chipStyle(partner.includes(val))}
                onClick={() => setPartner((prev) => toggle(prev, val))}
              >
                {label}
              </Button>
            ))}
          </Space>
        </div>

        <div style={{ marginBottom: 24 }}>
          <span style={sectionLabelStyle}>LSP</span>
          <Input
            placeholder="Search LSP name"
            value={lsp}
            onChange={(e) => setLsp(e.target.value)}
            style={{ borderRadius: 8 }}
          />
        </div>

        <div style={{ marginBottom: 24 }}>
          <span style={sectionLabelStyle}>Date Range</span>
          <RangePicker
            value={range}
            onChange={setRange}
            style={{ width: "100%", borderRadius: 8 }}
            allowClear
          />
        </div>
      </Drawer>
    </>
  );
}
